<div class="row">
    <div class="form-group col-md-6 col-lg-6 col-sm-12 col-xs-12 datepicker-custom ">
        <div class="form-inline">
            <div class="form-group">
                <input autocomplete="off" class="form-control " (click)="datePickerId.toggle()" placeholder="gg-mm-aaaa"
                    name="dp" [(ngModel)]="globalData.datePicker.dataSelezionata" ngbDatepicker #datePickerId="ngbDatepicker">

                <button (click)="globalData.aggiornaCalendarioRistorante(globalData.datePicker.dataSelezionata)"
                    skipLocationChange=true class="btn btn-primary" [disabled]="globalData.datePicker.dataSelezionata == null">Scegli
                    una data</button>
            </div>
        </div>
    </div>
</div>